<template>
  <div
    :class="['checkbox-group', `checkbox-group--${view}`, { 'checkbox-group--error': error, 'checkbox-group--disabled': disabled }]"
  >
    <div v-for="(item, i) in list" :key="i" class="checkbox-group__item">
      <CheckboxImage
        v-if="view === CHECKBOX_VIEW.card"
        class="checkbox-group__checkbox-card"
        :checked="isChecked(item.id)"
        :checked-value="item.id"
        :label="item.label"
        :image="item.image"
        :disabled="disabled"
        :error="error"
        @change="checked => onChange(item.id, checked)"
      />

      <Checkbox
        v-else
        class="checkbox-group__checkbox"
        :checked="isChecked(item.id)"
        :checked-value="item.id"
        :label="item.label"
        :disabled="disabled"
        :error="error"
        @change="checked => onChange(item.id, checked)"
      />
    </div>
  </div>
</template>

<script>
import Checkbox from './Checkbox.vue'
import CheckboxImage from './CheckboxImage.vue'

const CHECKBOX_VIEW = {
  default: 'default',
  card: 'card',
}

export default {
  name: 'CheckboxGroup',
  emits: ['input', 'change'],
  components: {
    Checkbox,
    CheckboxImage,
  },
  props: {
    value: {
      type: [Array, String], // TODO: String - legacy type, returned from backend
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    view: {
      type: String,
      default: CHECKBOX_VIEW.default,
      validator: value => {
        return [CHECKBOX_VIEW.default, CHECKBOX_VIEW.card].includes(value)
      },
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    CHECKBOX_VIEW() {
      return CHECKBOX_VIEW
    },
    normalizedValue() {
      if (Array.isArray(this.value)) return this.value

      return this.list.some(item => item.id === this.value) ? [this.value] : []
    },
  },
  methods: {
    isChecked(itemValue) {
      return this.normalizedValue.some(value => value === itemValue)
    },
    onChange(itemValue, isChecked) {
      const nextValue = isChecked ? [...this.normalizedValue, itemValue] : this.normalizedValue.filter(value => value !== itemValue)

      this.$emit('input', nextValue)
      this.$emit('change', nextValue)
    },
  },
}
</script>

<style lang="sass">
.checkbox-group
  display: grid
  gap: 12px

  &--default
    grid-template-columns: 1fr
    row-gap: 8px

  &--card
    grid-template-columns: repeat(3, minmax(0, 1fr))
    column-gap: 32px
    row-gap: 8px

  &__item
    display: flex

  &__checkbox
    width: 100%
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/CheckboxGroup.vue